<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered is-size-3">
                <span>
                    Operaciones actuales del usuario seleccionado
                </span>
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section style="background:#F8F9FD;" class="modal-card-body">
            <div style="background:#F8F9FD;" role="navigation" aria-label="main navigation" class="">
                <div class="">
                    <a class="mr-3 mb-3 button is-rounded" :class="{
                        'has-background-info-dark': selectedUser && selectedUser.user_id == user.user_id,
                        'has-background-info-light': selectedUser == null || selectedUser.user_id != user.user_id,
                        'has-text-white': selectedUser && selectedUser.user_id == user.user_id,
                        'has-text-black': selectedUser == null || selectedUser.user_id != user.user_id
                    }" @click="() => selectUser(user)" v-for="user in allUsers" v-bind:key="user.user_id">
                        {{ user.user_email }}
                    </a>
                </div>
            </div>
            <div class="blurry" id="data_div">
                <div class="columns is-multiline">
                    <div class="column is-12">
                        <InputWithValidation id="urlLooker" name="urlLooker" label="Url Looker:" v-model="urlLooker"
                            rules="required" />
                    </div>
                    <div class="column is-4">
                        <label class="checkbox">
                            <input type="checkbox" v-model="isActive" />
                            Puede ingresar a la plataforma
                        </label>
                    </div>
                    <div class="column is-4">
                        <label class="checkbox">
                            <input type="checkbox" v-model="noHasSIIMsg" />
                            No mostrar mensaje de conectar el SII
                        </label>
                    </div>
                    <div class="column is-4">
                        <label class="checkbox">
                            <input type="checkbox" v-model="hasConciliator" />
                            Tiene conciliador
                        </label>
                    </div>
                    <div class="column is-4">
                        <label class="checkbox">
                            <input type="checkbox" v-model="hasReport" />
                            Tiene reporte looker
                        </label>
                    </div>
                    <div class="column is-4">
                        <label class="checkbox">
                            <input type="checkbox" v-model="hasClassification" />
                            Tiene clasificador
                        </label>
                    </div>
                    <div class="column is-4">
                        <label class="checkbox">
                            <input type="checkbox" v-model="hasFinancialReport" />
                            Tiene reporte en linea
                        </label>
                    </div>
                    <div class="column is-4">
                        <label class="checkbox">
                            <input type="checkbox" v-model="hasFinanciamiento" />
                            Tiene Financiamiento
                        </label>
                    </div>
                </div>
                <div class="container" v-if="selectedUser">
                    <strong>Tipos de contraparte que el usuario puede ver:</strong>
                    <div class="options-grid">
                        <div v-for="counterpart in typeOptions" :key="counterpart.value">
                            <div class="is-flex is-flex-grow-2 is-flex-shrink-4">
                                <label class="checkbox">
                                    <input type="checkbox" v-model="counterpart.active"/>
                                    {{ counterpart.label }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <table class="table is-narrow">
                        <tbody>
                            <tr>
                                <td style="font-weight: 900;">-------------------</td>
                            </tr>
                            <tr>
                                <td>-------------------</td>
                            </tr>
                            <tr>
                                <td>-------------------</td>
                            </tr>
                            <tr>
                                <td>-------------------</td>
                            </tr>
                            <tr>
                                <td>-------------------</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
            <button class="button is-primary" :disabled="loading || selectedUser == null" role="button"
                @click="updateUserOperations()">
                Grabar
            </button>
        </footer>
    </div>
</template>

<script>
import { getUsersByCompany, updateUserOperations } from "@/api/carteraAnalista";
import InputWithValidation from "@/components/inputs/InputWithValidation";
export default {
    name: "ChangeOperationsByUsers",
    data() {
        return {
            loading: false,
            fileByUser: [],
            selectedUser: null,
            urlLooker: "",
            hasConciliator: false,
            hasClassification: false,
            hasFinancialReport: false,
            hasReport: false,
            noHasSIIMsg: false,
            isActive: false,
            canUploadFiles: false,
            hasFinanciamiento: false,
            allFiles: [],
            allUsers: [],
            typeOptions: []
        };
    },
    components: {
        InputWithValidation
    },
    methods: {
        selectUser(user) {
            this.selectedUser = user
            this.urlLooker = user.url_report
            this.hasConciliator = user.has_conciliator
            this.hasClassification = user.has_classificator
            this.hasFinancialReport = user.has_financial_report
            this.hasReport = user.has_embedded_report
            this.hasFinanciamiento = user.has_financiamiento
            this.noHasSIIMsg = user.no_sii_message
            this.isActive = user.is_active
            this.canUploadFiles = user.has_file_upload

            this.allFiles = this.selectedUser.all_files.map(file => {
                let newFile = { ...file }
                newFile.active = this.selectedUser.files_id.includes(newFile.id)
                return newFile
            })
            const userValidCounterparts = [...(this.selectedUser.user_valid_counterparts || [])]
            // Lista vacía = el usuario ve TODOS los tipos (misma semántica que
            // classification.js / DashboardClassificator) — se refleja con
            // todas las alternativas marcadas, no desmarcadas.
            const seesAll = userValidCounterparts.length === 0
            this.typeOptions = this.typeOptions.map(type => {
                return {
                    ...type,
                    active: seesAll || userValidCounterparts.includes(type.value)
                };
            });
            const myDiv = document.getElementById("data_div");
            if (myDiv) {
                myDiv.classList.remove("blurry");
            }
        },
        updateUserOperations() {
            const reqUserOps = {
                user_id: this.selectedUser.user_id,
                url_report: this.urlLooker,
                has_conciliator: this.hasConciliator,
                has_classificator: this.hasClassification,
                has_financial_report: this.hasFinancialReport,
                has_embedded_report: this.hasReport,
                no_sii_message: this.noHasSIIMsg,
                is_active: this.isActive,
                has_file_upload: this.canUploadFiles,
                has_financiamiento: this.hasFinanciamiento,
            }
            let counterpartTypes = []
            this.typeOptions.map(type=>{
                if(type.active){
                    counterpartTypes.push(type.value)
                }
            })
            reqUserOps.counterpart_types = counterpartTypes
            updateUserOperations(this.idCompany, reqUserOps).then(() => {
            }).finally(() => {
                this.$emit("close");
            })
        }
    },
    props: ["idCompany"],
    created() {
        getUsersByCompany(this.idCompany).then(({ data }) => {
            this.allUsers = data
        })
        this.typeOptions = [
            { value: "Cliente", label: "🤝 Cliente", active: false },
            { value: "Proveedor", label: "💼 Proveedor", active: false },
            { value: "Honorario", label: "🕒 Honorario", active: false },
            { value: 'Trabajador', label: '🧑‍💻 Trabajador', active: false },
            { value: 'Internacional', label: '🌍 Internacional', active: false },
            { value: 'Recibo', label: '🧾 Recibo', active: false },
            { value: 'Finiquito', label: '📄 Finiquito', active: false },
        ];
    },
};
</script>
<style scoped>
.blurry {
    margin-top: 30px;
    filter: blur(15px);
    background-color: rgb(248, 249, 253);
}
.options-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* Crea 2 columnas del mismo ancho */
    gap: 15px; /* Espacio entre las columnas y filas */
    margin-top: 10px; /* Un poco de separación con el título */
}
</style>